import { parseDateRangeString } from '@chocolate-soup-inc/cs-frontend-components';
import { endOfDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { TListAllLogsQuery, TListAllLogsQueryVariables, TLogFieldsFragment, useListAllLogsLazyQuery } from '../../generated/graphql';
import { TEmployeeType } from '../employees/queries';
import { useQueryAll } from '../shared/useQueryAll';
import { changelogGenerateFilters } from './utils';

// =========================
// NEW
// =========================

export type TLogType = TLogFieldsFragment & {
  company?: Record<string, any>;
  employee?: TEmployeeType;
  identity?: any;
  action?: string;
  entity?: string;
  response?: any;
  variables?: any;
  identityUserName?: string;
  identityUserEmail?: string;
};

export type TListLogsProps = {
  occurredAt?: any;
  companyId?: string;
};

export const useListAllLogsNew = (props: TListLogsProps) => {
  const occurredAt = useMemo(() => {
    // Local day boundaries include the whole selected range through its final day.
    const occurredParsed = typeof props.occurredAt === 'string' ? parseDateRangeString(props.occurredAt) : props.occurredAt || {};
    if (occurredParsed.from && occurredParsed.to)
      return JSON.stringify({
        operator: 'BETWEEN',
        value: [startOfDay(occurredParsed.from).toISOString(), endOfDay(occurredParsed.to).toISOString()]
      });

    if (occurredParsed.from) return JSON.stringify({ operator: '>=', value: startOfDay(occurredParsed.from).toISOString() });

    if (occurredParsed.to) return JSON.stringify({ operator: '<=', value: endOfDay(occurredParsed.to).toISOString() });

    return null;
  }, [props.occurredAt]);

  const filter = changelogGenerateFilters(props);

  //console.log('filter', filter);

  const {
    data: clientLogs,
    error: clientError,
    loading: clientLoading,
    nextToken: clientNextToken,
    fetchMore: clientFetchMore
  } = useQueryAll<TListAllLogsQuery, TListAllLogsQueryVariables>({
    useQuery: useListAllLogsLazyQuery,
    variables: { userType: 'client', occurredAt, filter, limit: 100 },
    isScroll: true
  });

  const {
    data: internalLogs,
    error: internalError,
    loading: internalLoading,
    nextToken: internalNextToken,
    fetchMore: internalFetchMore
  } = useQueryAll<TListAllLogsQuery, TListAllLogsQueryVariables>({
    useQuery: useListAllLogsLazyQuery,
    variables: {
      userType: 'internal',
      occurredAt,
      userPoolId: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID as string,
      filter,
      limit: 100
    },
    isScroll: true
  });

  const data = useMemo(() => [...(clientLogs?.listAllLogs.items || []), ...(internalLogs?.listAllLogs.items || [])] as TLogType[], [clientLogs, internalLogs]);

  return {
    data,
    error: clientError || internalError,
    loading: clientLoading || internalLoading,
    nextToken: { clientNextToken, internalNextToken },
    fetchMore: { clientFetchMore, internalFetchMore }
  };
};
export const useListAllLogsOld = (props: TListLogsProps) => {
  const occurredAt = useMemo(() => {
    // Local day boundaries include the whole selected range through its final day.
    const occurredParsed = typeof props.occurredAt === 'string' ? parseDateRangeString(props.occurredAt) : props.occurredAt || {};
    if (occurredParsed.from && occurredParsed.to)
      return JSON.stringify({
        operator: 'BETWEEN',
        value: [startOfDay(occurredParsed.from).toISOString(), endOfDay(occurredParsed.to).toISOString()]
      });

    if (occurredParsed.from) return JSON.stringify({ operator: '>=', value: startOfDay(occurredParsed.from).toISOString() });

    if (occurredParsed.to) return JSON.stringify({ operator: '<=', value: endOfDay(occurredParsed.to).toISOString() });

    return null;
  }, [props.occurredAt]);

  const filter = changelogGenerateFilters(props);

  //console.log('filter', filter);

  const {
    data: clientLogs,
    error: clientError,
    loading: clientLoading
  } = useQueryAll<TListAllLogsQuery, TListAllLogsQueryVariables>({
    useQuery: useListAllLogsLazyQuery,
    variables: { userType: 'client', occurredAt, filter }
  });

  const {
    data: internalLogs,
    error: internalError,
    loading: internalLoading
  } = useQueryAll<TListAllLogsQuery, TListAllLogsQueryVariables>({
    useQuery: useListAllLogsLazyQuery,
    variables: {
      userType: 'internal',
      occurredAt,
      userPoolId: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID as string,
      filter
    }
  });

  const data = useMemo(() => [...(clientLogs?.listAllLogs.items || []), ...(internalLogs?.listAllLogs.items || [])] as TLogType[], [clientLogs, internalLogs]);

  return {
    data,
    error: clientError || internalError,
    loading: clientLoading || internalLoading
  };
};
